<div class="modal-header d-flex justify-content-between align-items-center">
  <h4 class="modal-title">Add Feedback</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body">
  <form (ngSubmit)="submitFeedback()" #feedbackForm="ngForm">
    <div class="mb-3">
      <label for="feedbackContent" class="form-label">Feedback</label>
      <textarea
        id="feedbackContent"
        class="form-control"
        [(ngModel)]="content"
        name="content"
        rows="4"
        required
        placeholder="Enter your feedback here...">
      </textarea>
    </div>

    <div class="mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <label for="attachments" class="form-label">Attachments (optional)</label>
        <small class="text-muted d-block">
          Allowed file types: {{ allowedExtensions.join(', ') }}
        </small>
      </div>
      <input id="attachments" type="file" class="form-control" multiple (change)="onFileChange($event)" />
      
      <div *ngIf="selectedFiles.length" class="mt-2">
        <small class="text-muted">Selected files:</small>
        <ul class="mb-0 ps-3">
          <li *ngFor="let file of selectedFiles">
            {{ file.name }}
            <div *ngIf="uploadProgress.get(file.name) !== undefined" class="progress my-1">
              <div
                class="progress-bar progress-bar-striped"
                role="progressbar"
                [style.width.%]="uploadProgress.get(file.name)"
              >
                {{ uploadProgress.get(file.name) }}%
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button *appHasRole="[SystemRole.EXTERNAL]"
          type="button"
          class="btn"
          [ngClass]="isFeedbackCompleted ? 'btn-success' : 'btn-outline-secondary'"
          (click)="toggleFeedbackCompleted()">
    Feedback Completed
  </button>
  <button *appHasRole="[SystemRole.EXTERNAL]"
          type="button"
          class="btn"
          [ngClass]="isPlanogramApproved ? 'btn-success' : 'btn-outline-secondary'"
          (click)="togglePlanogramApproved()">
    Planogram Approved
  </button>
  <button type="button"
          class="btn btn-primary"
          [disabled]="submitting || !canSubmit"
          (click)="submitFeedback()">
    {{ submitting ? 'Submitting...' : 'Submit' }}
  </button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>